module.exports = (function () {
    // this will not work for Header and Footer on legacy pages, as they are considered
    // to be the same on all pages and their `location` is considered as `home page` always

    const localeUtils = require('utils/LanguageLocale');
    const PageTemplateType = require('constants/PageTemplateType');

    let Location = {};
    const basketURL = /^\/basket*/;
    const buyPageUrl = /^\/buy\/*/;
    const rewardsURL = /^\/rewards*/;
    const addReviewPageURL = /^\/addReview*/;
    const CUSTOM_SETS_HASH = '#customsets';
    const referrerURL = /^\/share/;
    const Storage = require('utils/localStorage/Storage');
    const LOCAL_STORAGE = require('utils/localStorage/Constants');

    function sanitizePathname(location) {
        const locationCopy = { ...location };
        locationCopy.pathname = locationCopy.pathname && locationCopy.pathname.replace(/ca\/en\/|ca\/fr\//g, '');

        return locationCopy;
    }

    function getWindowLocation(sanitize = false) {
        if (sanitize) {
            return sanitizePathname(window.location);
        } else {
            return window.location;
        }
    }

    function getLocation(sanitize = false) {
        return Sephora.location
            ? sanitize
                ? sanitizePathname(Sephora.location)
                : Sephora.location
            : !Sephora.isNodeRender
                ? getWindowLocation(sanitize)
                : { pathname: '' };
    }

    function setLocation(url) {
        const location = Location.getLocation();
        location.href = url;
    }

    function isBasketPage() {
        const location = Location.getLocation(true);

        return location.pathname && !!location.pathname.match(basketURL);
    }

    function isBuyPage(url) {
        if (url) {
            return !!url.match(buyPageUrl);
        } else {
            const location = Location.getLocation(true);

            return location.pathname && !!location.pathname.match(buyPageUrl);
        }
    }

    function isRewardsPage() {
        const location = Location.getLocation(true);

        return location.pathname && !!location.pathname.match(rewardsURL);
    }

    function isOffersPage() {
        const location = Location.getLocation(true);

        return Sephora.renderQueryParams.urlPath === '/beauty/beauty-offers' || location.pathname.indexOf('/beauty/beauty-offers') !== -1;
    }

    function isHolidayPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/holiday-sale') !== -1;
    }

    function isAtRiskPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/ways-to-save') !== -1;
    }

    function isPickupDeliveryOptionsPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/pick-up-delivery-options') !== -1;
    }

    function isAddReviewPage() {
        const location = Location.getLocation(true);

        return location.pathname && !!location.pathname.match(addReviewPageURL);
    }

    function isGalleryPage() {
        return Sephora.pagePath === PageTemplateType.Gallery;
    }

    function isGalleryAlbumPage() {
        const location = Location.getLocation(true);

        return /\/gallery\/album\/.*/.test(location.pathname);
    }

    function isCustomSets(hash) {
        return new RegExp(CUSTOM_SETS_HASH).test(hash || Location.getLocation().hash);
    }

    function isMyProfilePage() {
        const location = Location.getLocation();

        return location.pathname.indexOf('/profile/me') !== -1;
    }

    function isAccountPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/account') === 0 || location.pathname.indexOf('/profile/MyAccount') === 0;
    }

    function isReplacementOrderPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/profile/MyAccount/replacementOrder') === 0;
    }

    function isRichProfilePage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/profile') === 0;
    }

    function isCheckout() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/checkout') === 0;
    }

    function isPreview() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/preview') === 0;
    }

    function isPreviewSettings() {
        return Sephora.pagePath === PageTemplateType.PreviewSettings;
    }

    function isProd() {
        const location = Location.getLocation();

        return location.href.match(/(www|m)\.sephora\.com/) !== null;
    }

    function isBrandNthCategoryPage() {
        return Sephora.pagePath === PageTemplateType.BrandNthCategory || Sephora.pagePath === PageTemplateType.RwdBrandNthCategory;
    }

    function isHomePage() {
        return Sephora.pagePath === PageTemplateType.Homepage || Sephora.pagePath === PageTemplateType.RwdHomepage;
    }

    function isRootCategoryPage() {
        return Sephora.pagePath === PageTemplateType.Category;
    }

    function isNthCategoryPage() {
        return Sephora.pagePath === PageTemplateType.NthCategory || Sephora.pagePath === PageTemplateType.RwdNthCategory;
    }

    function isProductPage() {
        return Sephora.pagePath === PageTemplateType.ProductPage;
    }

    function isRwdContentStorePage() {
        return Sephora.pagePath === PageTemplateType.RwdContentStore;
    }

    function isPublicLovesPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/lovelist') === 0;
    }

    function isOrderConfirmationPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/checkout/confirmation') === 0;
    }

    function isGalleryProfilePage() {
        const location = Location.getLocation(true);

        return (
            location.pathname === '/myprofile' ||
            location.pathname === '/myprofile/photos' ||
            location.pathname === '/gallery/myprofile/photos' ||
            location.pathname === '/gallery/myprofile/loved'
        );
    }

    function isContentStorePage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/') === 0 && !Location.isContactUsPage() && !Location.isOrderStatusPage();
    }

    function isCreditCardApplyPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/creditcard-apply') === 0;
    }

    function isCreditCardTabPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/profile/CreditCard') === 0;
    }

    function isCreditCardMarketingPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/creditcard') === 0;
    }

    function isSearchPage() {
        return Sephora.pagePath === PageTemplateType.Search || Sephora.pagePath === PageTemplateType.RwdSearch;
    }

    function isNoSearchResultsPage() {
        return Sephora.pagePath === PageTemplateType.ZeroSearchResults || Sephora.pagePath === PageTemplateType.RwdNullSearchResults;
    }

    function isBIPage() {
        return Sephora.pagePath === PageTemplateType.BeautyInsider;
    }

    function isTargetedLandingPage() {
        return Sephora.pagePath === PageTemplateType.BeautyWinPromo;
    }

    function isBIRBPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/rewards') === 0;
    }

    function isSalePage() {
        const salePathRegExp = /^.*\/sale\?*$/i;
        const location = Location.getLocation(true);

        return location.pathname.match(salePathRegExp) !== null;
    }

    function isOnlineReservationLandingPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/happening/home') === 0;
    }

    function isContactUsPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/contact-us') === 0;
    }

    function isOrderStatusPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/order-status') === 0;
    }

    function isPurchaseHistoryPage() {
        return Sephora.pagePath === PageTemplateType.PurchaseHistory;
    }

    function isLovesListPage() {
        return Sephora.pagePath === PageTemplateType.ShoppingList;
    }

    function isReferrerPage() {
        const location = Location.getLocation(true);

        return location.pathname && !!location.pathname.match(referrerURL);
    }

    function reload() {
        window.location.reload();
    }

    function isExperienceDetailsPage() {
        const location = Location.getLocation(true);

        return (
            location.pathname.indexOf('/happening/classes') === 0 ||
            location.pathname.indexOf('/happening/services') === 0 ||
            location.pathname.indexOf('/happening/events') === 0 ||
            location.pathname.indexOf('/happening/announcements') === 0
        );
    }

    function isMySephoraPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/profile/BeautyPreferences') === 0;
    }

    function isSavingsEventPage() {
        const location = Location.getLocation(true);

        return location.pathname.indexOf('/beauty/savings-event') !== -1;
    }

    function getPageTitle(template) {
        const getText = localeUtils.getLocaleResourceFile('utils/locales', 'Location');

        const pagesTitles = {
            [PageTemplateType.Basket]: getText('basket'),
            [PageTemplateType.BrandsList]: getText('brandsList'),
            [PageTemplateType.Lists]: getText('lists'),
            [PageTemplateType.ShoppingList]: getText('lovesList'),
            [PageTemplateType.PurchaseHistory]: getText('purchaseHistory'),
            [PageTemplateType.InstoreServices]: getText('inStoreServices'),
            [PageTemplateType.AddReviewPage]: getText('writeAReview'),
            [PageTemplateType.Confirmation]: getText('orderConfirmation'),
            [PageTemplateType.OrderDetails]: getText('orderDetail'),
            [PageTemplateType.Profile]: getText('profile'),
            [PageTemplateType.BeautyInsider]: getText('beautyInsider'),
            [PageTemplateType.MyAccount]: getText('myAccount'),
            [PageTemplateType.Orders]: getText('recentOrders'),
            [PageTemplateType.Subscriptions]: getText('subscriptions'),
            [PageTemplateType.AutoReplenishment]: getText('autoReplenishment'),
            [PageTemplateType.MyReservations]: getText('reservations'),
            [PageTemplateType.Addresses]: getText('savedAddresses'),
            [PageTemplateType.PaymentMethods]: getText('paymentsAndCredits'),
            [PageTemplateType.EmailPostal]: getText('emailAndMailPreferences'),
            [PageTemplateType.Community]: getText('beautyForum'),
            [PageTemplateType.Gallery]: getText('gallery'),
            [PageTemplateType.AddPhoto]: getText('addPhoto'),
            [PageTemplateType.Departments]: getText('sitemapDepartments'),
            [PageTemplateType.BeautyPreferences]: getText('beautyPreferences')
        };

        return pagesTitles[template];
    }

    function isVendorLoginPage() {
        return Sephora.pagePath === PageTemplateType.VendorLogin;
    }

    function isVendorGenericLogin() {
        return Sephora.pagePath === PageTemplateType.VendorGenericLogin;
    }

    function updateSeoCanonicalUrl(seoCanonicalUrl) {
        const { SEPHORA_URL } = require('components/constants');
        const { getLink } = require('utils/Url');

        const seoCanonicalUrlLink = document.getElementById('seoCanonicalUrl');

        if (seoCanonicalUrlLink) {
            seoCanonicalUrlLink.setAttribute('href', getLink(`${SEPHORA_URL.DESKTOP}${seoCanonicalUrl}`));
        }
    }

    function isConstructorEnabledPage() {
        const constructorDisabledPages = [
            PageTemplateType.Checkout,
            PageTemplateType.MyAccount,
            PageTemplateType.PaymentMethods,
            PageTemplateType.Addresses
        ];

        return constructorDisabledPages.indexOf(Sephora.pagePath) === -1;
    }

    function isCaliforniaConsumer() {
        const isCaliforniaConsumerDetected = Storage.session.getItem(LOCAL_STORAGE.IS_CALIFORNIA_CONSUMER);

        if (isCaliforniaConsumerDetected === null) {
            const isCalifornia = Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE)?.address?.state === 'CA';
            Storage.session.setItem(LOCAL_STORAGE.IS_CALIFORNIA_CONSUMER, isCalifornia);

            return isCalifornia;
        }

        return isCaliforniaConsumerDetected;
    }

    Location = {
        isAccountPage,
        isBasketPage,
        isBuyPage,
        isRewardsPage,
        isOffersPage,
        isBrandNthCategoryPage,
        isAddReviewPage,
        isMyProfilePage,
        isRichProfilePage,
        isRootCategoryPage,
        isNthCategoryPage,
        isPreview,
        isProd,
        isCheckout,
        isOrderStatusPage,
        isPurchaseHistoryPage,
        isHomePage,
        isGalleryPage,
        isProductPage,
        isRwdContentStorePage,
        isGalleryProfilePage,
        isContentStorePage,
        isSearchPage,
        isNoSearchResultsPage,
        isGalleryAlbumPage,
        isOrderConfirmationPage,
        isPublicLovesPage,
        isCustomSets,
        isBIPage,
        isBIRBPage,
        getLocation,
        getWindowLocation,
        setLocation,
        isCreditCardApplyPage,
        isCreditCardTabPage,
        isCreditCardMarketingPage,
        isSalePage,
        isOnlineReservationLandingPage,
        isTargetedLandingPage,
        isContactUsPage,
        isLovesListPage,
        isReferrerPage,
        reload,
        isExperienceDetailsPage,
        PAGES: { CUSTOM_SETS_HASH: CUSTOM_SETS_HASH },
        getPageTitle,
        sanitizePathname,
        isVendorLoginPage,
        isVendorGenericLogin,
        updateSeoCanonicalUrl,
        isPreviewSettings,
        isConstructorEnabledPage,
        isHolidayPage,
        isCaliforniaConsumer,
        isAtRiskPage,
        isPickupDeliveryOptionsPage,
        isMySephoraPage,
        isReplacementOrderPage,
        isSavingsEventPage
    };

    return Location;
}());
